<script>
  import Button from '@components/buttons/button.svelte'
  import { Info, RotateCcw } from 'lucide-svelte'
  import { setParam, clearParams, hasParams } from '@lib/utils'

  let { 
    filters, 
    pagination = { summary: null, previous: null, next: null }, 
    paginationProps = {}
  } = $props()

  let defaultPaginationProps = { summary: false, icon: Info, terms: ["item", "items"] }

  let derivedPaginationProps = $derived(Object.assign({}, defaultPaginationProps, paginationProps))

  let summary = $derived.by(() => {
    if (!derivedPaginationProps?.summary || !pagination?.summary) return null
    return pagination.summary.replace("items", derivedPaginationProps.terms[1]).replace("item", derivedPaginationProps.terms[0])
  })

  function previous() {
    setParam('page', pagination.previous)
  }

  function next() {
    setParam('page', pagination.next)
  }

  function refresh() {
    // if (hasParams(["page"])) return clearParams({ keys: ["page"] })
    clearParams()
  }

</script>

<div class="flex flex-col gap-2 md:gap-0 md:flex-row md:justify-between md:items-center mb-6">

  <!-- Filters snippet -->
  {#if filters}
    <div class="flex items-center gap-2">
      {@render filters()}
    </div>
  {/if}

  <!-- Pagination -->
  <div class="flex justify-between md:justify-start gap-2">
    
    <!-- The pagination summary (if enabled) -->
    {#if summary}
      <div class="mr-3 flex gap-2 items-center text-smaller text-gray-500">
        <p>{summary}</p>
        {#if derivedPaginationProps?.icon}
          <derivedPaginationProps.icon size={14} strokeWidth={1.5} class="text-gray-500/80" />
        {/if}
      </div>
    {/if}
    
    <!-- The next/previous buttons -->
    <div class="flex items-center gap-2">
      <Button size="sm" onclick={previous} disabled={!pagination.previous}>Previous</Button>
      <Button size="sm" onclick={next} disabled={!pagination.next}>Next</Button>
      <Button size="sm" onclick={refresh} Icon={RotateCcw} />
    </div>

  </div>

</div>